<template>
    <div class="approve_wrap">
        <div class="admin_top">
            <div class="admin_top_tab">
                <ul>
                    <li
                        @click="handleClickTab(item)"
                        :class="item.name == activeName ? 'active' : ''"
                        v-for="item in tabList"
                        v-if="item.show"
                        v-text="item.label"
                    ></li>
                </ul>
            </div>
        </div>
        <div class="admin_bottom">
            <div v-if="activeName === 'initiateApproval'">
                <initiateApproval @lookApprovalCenter="lookApprovalCenter"></initiateApproval>
            </div>
            <div v-if="activeName === 'approvalCenter'">
                <approvalCenter ref="approvalCenter"></approvalCenter>
            </div>
            <div v-if="activeName === 'dataManagement'">
                <dataManagement></dataManagement>
            </div>
        </div>
    </div>
</template>
<script>
import initiateApproval from "./initiateApproval";
import approvalCenter from "./approvalCenter";
import dataManagement from "./dataManagement";
import {getButtonPermissions} from  "@/utils"
export default {
    name: "Approve",
    components: {
        initiateApproval,
        approvalCenter,
        dataManagement,
    },
    data() {
        return {
            activeName: "initiateApproval",
            tabList: [
                { name: "initiateApproval", label: "发起审批" ,show:true},
                { name: "approvalCenter", label: "审批中心",show:true },
                { name: "dataManagement", label: "数据管理" ,show:false},
            ],
        };
    },
    mounted() {
        if(this.getButtonPermissions("approvalData.list")){
            this.tabList.find(item=>item.name=="dataManagement").show = true
        }
        // this.$route.meta.admin.permission = true;
    },
    methods: {
        getButtonPermissions(btn){
            return  getButtonPermissions(btn)
        },
        handleClickTab(item) {
            if (item.name == "approvalCenter") {
                this.lookApprovalCenter("");
            } else {
                this.activeName = item.name;
            }
        },
        lookApprovalCenter(state) {
            this.activeName = "approvalCenter";
            this.$nextTick(() => {
                this.$refs.approvalCenter && this.$refs.approvalCenter.initData(state);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/approval.scss";
</style>
